import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  DatePicker,
  TimePicker,
  message,
  Checkbox,
} from "antd";
import { platformApi } from "../../../../../api";
import moment from "moment";

const { Item } = Form;
const { Text } = Typography;
const { Option } = Select;

const ScheduleData = ({
  form,
  data,
  id,
  editable,
  recvData,
  setGroupCount,
  checked,
  setChecked,
  validate,
  setValidate
}) => {
  // const [id, setId] = useState("");
  const [group, setGroup] = useState([]);
  // const [groupCount, setGroupCount] = useState(0)
  const { getFieldDecorator, getFieldValue } = form;


  useEffect(() => {
    form.setFieldsValue({
      date: data.date,
      time: data.time,
      group: data.group,
    });

    validate.add(validatePage)
    setValidate(validate)

    platformApi.get("/api/promotions").then((res) => {
      if (res.status === 200) {
        let data = res.data;
        if (data.code === 200) {
          let resp = data.response;
          if (resp.code === 200) {
            let response = resp.data;
          }
        }
      }
    });

    platformApi
      .get("/api/promotions/group/")
      .then((res) => {
        // setSpinning(false);
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setGroup(response.data);

          } else {
            message.error("Unable to fetch Groups", 2);
          }
        } else {
          message.error("Unable to fetch Groups", 2);
        }
      })
      .catch((err) => {
        // setSpinning(false);
        console.error("Error on Group : ", err);
        message.error("Unable to fetch Groups", 2);
      });
  }, []);

  useEffect(() => {
    if (recvData) {
      form.setFieldsValue({
        date: moment(recvData.executionTime),
        time: moment(recvData.executionTime),
        group: recvData.group.id,
      });
      // setStartDate(recvData.execution);
      // setStartTime(recvData.execution);
    }
  }, [recvData, editable]);

  // Keep date/time fields in sync when Reschedule updates local data
  useEffect(() => {
    if (data.date || data.time) {
      form.setFieldsValue({
        date: data.date || getFieldValue("date"),
        time: data.time || getFieldValue("time"),
      });
      if (data.date && typeof setChecked === "function") {
        setChecked(false);
      }
    }
  }, [data.date, data.time]);


  const onCheck = (event) => {
    if (event.target.checked) {
      setChecked(true)
    }
    else {
      setChecked(false)
    }
  }


  const getDisabledHours = () => {
    var hours = [0, 1, 2, 3, 4, 5, 6, 7, 20, 21, 22, 23];

    return hours;
  }


  const validatePage = () => {
    let isValid;
    form.validateFields((validationError) => {
      isValid = validationError === null;
    });
    if (isValid) {
      data.date = getFieldValue("date");
      data.time = getFieldValue("time");
      data.group = getFieldValue("group");
      data.taskId = id;
    }
    return isValid;
  };

  return (
    <Form style={{ marginTop: "4%", marginBottom: "0.5rem" }} onLoad >
      <Row>
        <Col>
          <Text strong>Promotional Task ID :</Text>
          &nbsp;{id}
        </Col>
      </Row>
      {editable && (
        <Row style={{ marginTop: "0.75rem", marginBottom: "1.25rem" }}>
          <Col span={7}>
            <Checkbox
              checked={checked}
              onChange={(event) => { onCheck(event) }}
            >
              Start Now
            </Checkbox>
          </Col>
        </Row>
      )}
      <Row type="flex" style={{ marginBottom: 0 }}>
        <Col span={7}>
          <Item label={<Text>Execution Date</Text>} colon={false}>
            {getFieldDecorator("date", {
              rules: [{ required: !checked, message: "Execution Date Required" }],
            })(
              <DatePicker
                format="DD/MM/YYYY"
                disabledDate={(moment) =>
                  Date.now() - 1000 * 60 * 60 * 24 > moment._d
                }
                disabled={!editable || checked}
                onChange={(date) => {
                  if (!date) {
                    form.setFieldsValue({ time: null });
                  }
                }}
              />
            )}
          </Item>
        </Col>
        <Col span={7}>
          <Item label={<Text>Execution Time</Text>} colon={false}>
            {getFieldDecorator("time", {
              rules: [{ required: !checked, message: "Execution Time Required" }],
            })(
              <TimePicker
                format="HH:mm"
                style={{ width: "13rem" }}
                disabled={!editable || checked || !getFieldValue("date")}
                disabledHours={getDisabledHours}
                disabledMinutes={(selectedHour) => {
                  const selectedDate = getFieldValue("date");
                  const today = moment().startOf('day');
                  const currentHour = moment().hour();
                  const currentMinute = moment().minute();

                  // If date is not today, return empty array (all minutes enabled)
                  if (!selectedDate || !selectedDate.isSame(today, 'day')) {
                    return [];
                  }

                  // If selected hour is current hour, disable minutes after current minute
                  if (selectedHour === currentHour) {
                    const disabledMinutes = [];
                    for (let i = 0; i <= currentMinute; i++) {
                      disabledMinutes.push(i);
                    }
                    return disabledMinutes;
                  }

                  // For future hours, return empty array (all minutes enabled)
                  return [];
                }}
              />
            )}
          </Item>
        </Col>
        <Col span={5}>
          <Item label="Select Group" colon={false}>
            {getFieldDecorator("group", {
              rules: [{ required: true, message: "Group Required" }],
            })(
              <Select
                showAction={["click", "focus"]}
                disabled={!editable}
                placeholder="Select Group"
                style={{ width: "13rem" }}
                onChange={(id) => {
                  group.map((each) => {
                    if (each.id === id) {
                      setGroupCount(each.count)
                    }
                  })
                }}
              >
                {group.map((grp) => (
                  <Option key={grp.id}>{grp.groupName}</Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
      </Row>
    </Form>
  );
};

const WrappedScheduleData = Form.create()(ScheduleData);

export default WrappedScheduleData;
